import React from "react";
import { Link } from "react-router-dom";
import { Reveal, MaskLine } from "../components/Motion";
import { ArrowRight } from "lucide-react";

const STATS = [
  { n: "8%", l: "Of every order donated" },
  { n: "100%", l: "Traceable giving" },
  { n: "0", l: "People left in the cold" },
];

export default function Mission() {
  return (
    <div data-testid="mission-page">
      <div className="relative h-[70vh] min-h-[460px] overflow-hidden">
        <img src="/brand/duo.png" alt="Mission" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-bg/60" />
        <div className="absolute bottom-10 left-0 w-full">
          <div className="max-w-[1500px] mx-auto px-4 sm:px-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cs-green mb-4">The Mission</p>
            <h1 className="font-display font-extrabold text-6xl sm:text-8xl uppercase leading-[0.82]">
              <MaskLine>Wear warmth</MaskLine>
              <MaskLine delay={0.1}>forward</MaskLine>
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-20 sm:py-28">
        <Reveal>
          <p className="font-editorial text-2xl sm:text-3xl leading-[1.4]">
            We donate <span className="text-cs-green">8% of every single purchase</span> to organizations helping people in poverty — the ones who struggle through the cold with no clothes to warm up in.
          </p>
          <p className="text-graytx mt-8 leading-relaxed">
            Streetwear is about how you show up in the world. We think that should mean something. So while you're layering up in washed black denim and distressed cotton, a share of what you spend goes straight to warm clothing, blankets, and shelter for people who don't get to choose their layers.
          </p>
          <p className="text-graytx mt-6 leading-relaxed">
            No fine print, no rounding down. Ten percent of the total, every order, every drop. Because the same fabric that gives you swagger can keep someone else alive through the winter.
          </p>
        </Reveal>
      </div>

      <div className="max-w-[1100px] mx-auto px-4 sm:px-8 pb-16 grid grid-cols-3 gap-4 sm:gap-8">
        {STATS.map((s, i) => (
          <Reveal key={i} delay={i * 0.1} className="border-t border-line pt-6">
            <p className="font-display font-extrabold text-4xl sm:text-6xl text-cs-green">{s.n}</p>
            <p className="text-graytx text-sm mt-2">{s.l}</p>
          </Reveal>
        ))}
      </div>

      <DonationSection />

      <div className="max-w-[1100px] mx-auto px-4 sm:px-8 pb-24 sm:pb-32">
        <Reveal className="bg-charcoal p-10 sm:p-16 text-center">
          <h2 className="font-display font-extrabold text-3xl sm:text-5xl uppercase leading-[0.95]">Shop the drop.<br />Fight the cold.</h2>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
            <Link to="/shop" className="inline-flex items-center justify-center gap-2 bg-cream text-bg font-mono text-[12px] uppercase tracking-[0.2em] px-8 py-4 hover:bg-cs-green hover:text-cream transition-colors duration-200" data-testid="mission-shop-btn">
              Shop the Drop <ArrowRight size={15} />
            </Link>
            <Link to="/donate" className="inline-flex items-center justify-center gap-2 border border-cream/40 font-mono text-[12px] uppercase tracking-[0.2em] px-8 py-4 hover:bg-cream hover:text-bg transition-colors duration-200" data-testid="mission-donate-btn">
              Support the Brand <ArrowRight size={15} />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
